import type { SegmentItemAo } from '@/apis/flights/model';

import { BookingTopInfo, ContactInfo, FlightPriceInfo, PaymentInformation } from '@/logic/order/model';
export interface Airports {
	airportCode: string;
	airportNameCn: string;
	airportNameEn: string;
	airportNameHk: string;
	airportNameJa: string;
	airportNameKo: string;
	cityCode: string;
	cityNameCn: string;
	cityNameEn: string;
	cityNameHk: string;
	cityNameJa: string;
	cityNameKo: string;
}
export interface Purchase {
	id: number,
	auxOrderId: number,
	auxPsgId: number,
	auxFlightId: number,
	productId: number,
	buyNum: number,
	buyStatus: number;
}
export interface Flight {
	id: 730,
	auxOrderId: 515,
	issueFlightId: 2622,
	carrierCode: string,
	flightNumber: string,
	depAirport: string,
	arrAirport: string,
	depTime: string,
	arrTime: string,
	cabinCode: string,
	cabinClass: string,
	flightOption: number,
	flightIndex: number;
}
export interface Segments {
	stopCities: string;
	airModel: string;
	flightId: number;
	cabin: string;
	flightFromCityCode: string;
	ifStop: string;
	duration: number;
	cabinLevel: string | null;
	seatsRemain: string;
	carrierName: string;
	stayTime: string;
	codeShare: string;
	arrAirport: string;
	depTerminal: string;
	depTime: string;
	flightToCityCode: string;
	depAirport: string;
	stopTimes: string;
	bagg_num: string;
	flightNumber: string;
	carrier: string;
	aircraftCode: string;
	arrTerminal: string;
	arrTime: string;
	bagg_unit: string;
}
export interface Order {
	payTotalPrice: number;
	seamanNum: number;
	adultTax: number;
	studentPrice: number;
	childTax: number;
	studentTax: number;
	adultPrice: number;
	needPayCurrency: string;
	seamanPrice: number;
	fromSegments: SegmentItemAo[],
	infantNum: number;
	currency: string;
	orderPrice: number;
	commission: string;
	id: number;
	seamanTax: number;
	laborTax: number;
	createDate: string;
	orderNo: string;
	childNum: number;
	adultNum: number;
	orderTicketPrice: number;
	sessionId: string;
	laborPrice: number;
	infantPrice: number;
	laborNum: number;
	sellLuggage: boolean;
	pnr: string;
	payCurrency: string;
	orderTaxPrice: number;
	childPrice: number;
	retSegments: SegmentItemAo[];
	payStatus: string;
	infantTax: number;
	studentNum: number;
	needPayTotalPrice: string;
	status: number;
}
export interface ConcatAo {
	id: number,
	orderid: number,
	name: string,
	gender: string | null,
	mobile: string,
	mobileCountry: string,
	countryTel: string,
	email: string,
	city?: string | null,
	district?: string,
	area: string,
	address: string,
	postcode: string,
	deliverytime: string,
	remarks: string;
}
export interface AuxBaggeInfo4FrontObj {
	saleCurrency: string;
	salePrice: string;
	baggageAllowance: string;
	baggagePieces: number;
	tripType: number;
}
export interface Passenger {
	id: number;
	ageType: string;
	birthday: string;
	gender: string;
	familyName: string;
	middleName?: string;
	givenName: string;
	cardType: string;
	cardTypeName: string;
	cardNum: string;
	cardIssuePlace: string;
	cardExpired: string;
	nationality: string;
	mobile: string;
	airlineCode: string;
	airlineCardNo: string;
	ticketNo: string;
	passengerId: string;
	auxBaggeInfo4FrontList: AuxBaggeInfo4FrontObj[];
}
export interface AuxOrderProductBaggage {
	id: string;
	productId: number;
	baggagePieces: number;
	baggageAllowance: string;
	isAllWeight: boolean;
}
export interface AuxOrderProductRule {
	id: number,
	productId: number,
	canRefund: number,
	canRefundIndependent: number,
	refundRule: string,
	canModify: number,
	canModifyIndependent: number,
	modifyRule: string;
}
export interface Product {
	id: number;
	auxOrderId: number;
	extId: number;
	productType: number;
	saleType: number;
	basePrice: number;
	currency: string;
	exchangeRate: number;
	salePrice: number;
	saleCurrency: string;
	dataSource: string;
	auxOrderProductBaggage: AuxOrderProductBaggage;
	auxOrderProductRule: AuxOrderProductRule;
}
export interface PaymentInfo {
	id: string | null,
	orderid: string,
	paytime: string,
	tradeno: string,
	channelid: string,
	cardno: string,
	cardholder: string,
	cardtype: string,
	currency: string,
	price: number,
	paidprice: number,
	status: number;
	channelName: string;
	commission: string;
}
export interface AuxOrder {
	payTotalPrice: number;
	auxOrderNo: string;
	auxOrderId: number;
	issueOrderId: number;
	needPayCurrency: string;
	issueOrderNo: string;
	type: string;  //1、一次购买 2、二次购买
	purchaseList: Purchase[];
	flightList: Flight[];
	createTime: number;
	payCurrency: string;
	passengerList: Passenger[];
	payStatus: number;
	needPayTotalPrice: string;
	productList: Product[];
	status: number;
}
export interface OrderDetailAo {
	airports: Airports[];
	auxOrderList: AuxOrder[];
	contact: ConcatAo;
	order: Order;
	passengerList: Passenger[];
	paymentInfo: PaymentInfo;
}
export interface PayChannelsData {
	id: number;
	name: string;
	min_amount: number;
	max_amount: number;
	currency: string;
	icon: string;
	allow_refund: number;
	processMode: number;
	type: number;
	commission: number;
	amountWithCommission: number;
	channel_name: string;
	amount: number;
	payRate: string;
	payRateOrg: string;
	payRateChange: string;
	extraPricePay: number;
	perExtraPricePay: number;
	perCommissionPay: number;
	fee_rate?: any;
	fixed_fee?: any;
	fixed_usd_fee?: any;
	fail_fee?: any;
	refund_fee?: any;
	refuse_fee?: any;
	deposit_days?: any;
}
interface CurrecyChannelData {
	amount: number;
	currency: string;
	payChannels: PayChannelsData[];
}
export interface OrderChannelAo {
	FirstCurrency: CurrecyChannelData;
	SecondCurrency: CurrecyChannelData;
	OtherCurrency: CurrecyChannelData[];
	defaultCurrency: string;
	defaultFazId: number;
}
// let { airports, auxOrderList, contact, order, passengerList, paymentInfo } = res;
export const convertOrderAoToLo = (orderDetailAo: OrderDetailAo) => {
	const { order, passengerList, contact, auxOrderList, paymentInfo, airports } = orderDetailAo;
	// 订单信息
	const orderLo = new BookingTopInfo();
	orderLo.orderStatus = order.status;
	orderLo.orderId = order.id;
	orderLo.orderPnr = order.pnr;
	orderLo.orderNo = order.orderNo;
	// 联系人信息
	const contactLo = new ContactInfo();
	contactLo.name = contact.name;
	contactLo.mobile = contact.mobile;
	contactLo.email = contact.email;
	contactLo.mobileTel = contact.countryTel;
	const orderFlightPriceLo = orderFlightPriceAoToLo(order);
	// 支付信息
	const paymentInfoLo = new PaymentInformation();
	paymentInfoLo.channelName = paymentInfo.channelName;
	paymentInfoLo.paytime = paymentInfo.paytime;
	paymentInfoLo.currency = paymentInfo.currency;
	paymentInfoLo.price = paymentInfo.price;
	paymentInfoLo.commission = paymentInfo.commission;
	return { orderLo, passengerList, contactLo, auxOrderList, orderFlightPriceLo, paymentInfoLo, order, airports };
};

export const orderFlightPriceAoToLo = (order: Order) => {
	// 订单价格信息
	const orderFlightPriceLo = new FlightPriceInfo();
	orderFlightPriceLo.adultNum = order.adultNum;
	orderFlightPriceLo.childNum = order.childNum;
	orderFlightPriceLo.infantNum = order.infantNum;
	orderFlightPriceLo.studentNum = order.studentNum;
	orderFlightPriceLo.laborNum = order.studentNum;
	orderFlightPriceLo.seamanNum = order.seamanNum;
	orderFlightPriceLo.adultPrice = order.adultPrice;
	orderFlightPriceLo.adultTax = order.adultTax;
	orderFlightPriceLo.childPrice = order.childPrice;
	orderFlightPriceLo.childTax = order.childTax;
	orderFlightPriceLo.infantPrice = order.infantPrice;
	orderFlightPriceLo.infantTax = order.infantTax;
	orderFlightPriceLo.studentPrice = order.studentPrice;
	orderFlightPriceLo.studentTax = order.studentTax;
	orderFlightPriceLo.laborPrice = order.laborPrice;
	orderFlightPriceLo.laborTax = order.laborTax;
	orderFlightPriceLo.seamanPrice = order.seamanPrice;
	orderFlightPriceLo.seamanTax = order.seamanTax;
	orderFlightPriceLo.orderTicketPrice = order.orderTicketPrice;  //订单的航班总票面价
	orderFlightPriceLo.orderTaxPrice = order.orderTaxPrice;//订单的航班总税价
	orderFlightPriceLo.payTotalPrice = order.payTotalPrice;  //订单总价原价格
	orderFlightPriceLo.payCurrency = order.payCurrency; //订单总价原币种
	orderFlightPriceLo.commission = order.commission;
	orderFlightPriceLo.payCommissionWithTotalPrice = Number(order.payTotalPrice);
	return orderFlightPriceLo;
};
export const convertOrderSystemAoToLo = (payChannel: OrderChannelAo) => {
	let payChannelList: CurrecyChannelData[] = [];
	if (payChannel.FirstCurrency && payChannel.FirstCurrency.currency) {
		payChannelList.push(payChannel.FirstCurrency);
	}
	if (payChannel.SecondCurrency && payChannel.SecondCurrency.currency) {
		payChannelList.push(payChannel.SecondCurrency);
	}
	if (payChannel.OtherCurrency && payChannel.OtherCurrency.length > 0) {
		payChannelList = [...payChannelList, ...payChannel.OtherCurrency];
	}
	if (!payChannel.defaultCurrency) {
		if (payChannelList.length > 0) {
			payChannel.defaultCurrency = payChannelList[0].currency;
		}
	}
	return { payChannelList, defaultCurrency: payChannel.defaultCurrency, defaultFazId: payChannel.defaultFazId };
};
export interface CreateOrderParams {
	cid: string;
	memberId: string;
	passengers: string;
	sessionId: string;
	servicePhone: string;
	contact: string;
	passengerAuxs?: any; //辅营
}
